export default __webpack_public_path__ + "static/sol-section-2-img-18222a580f354138d1e4e3572c152283.png";